// extracted by mini-css-extract-plugin
export default {"SaveRow":"SaveButton_SaveRow__U3zUH","PublishBtn":"SaveButton_PublishBtn__bNnqn","SaveSuccess":"SaveButton_SaveSuccess__CEeJN"};